function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, addingBlock, prefixRenderer, stagingSelected) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['multi-block-item'] = function(selection, idx) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((prefixRenderer) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-query-multi-block-prefix': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(prefixRenderer(idx, selection));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        const serializedSelection = JSON.stringify(selection);;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "key": serializedSelection,
          "class": {
            'mp-query-multi-block-item': true
          },
        }, (function() {
          var __jade_nodes = []; /*  Multi-block Supports add/removing vs select(toggling) values */
          /*  therefore regular query-block tracking is disabled in favor of */
          /*  tracking by multi-block */
          __jade_nodes = __jade_nodes.concat(h("mp-query-block", {
            "attrs": __vjadeStringifyAttrsIfObj($helpers.getQueryBlockAttrs({
              'elref': `queryBlock`,
              'prefix-label': $attr(idx === 0 ? `first-block-prefix` : `block-prefix`),
              'removable': true,
              'selected': serializedSelection,
              'tooltip-data': $attr(`tooltip-data-index`) === idx && $attr(`tooltip-data`),
            })),
            "on": {
              remove: () => $helpers.removeSelection(selection),
              select: ev => $helpers.modifySelection(idx, ev),
              track: $helpers.preventTracking,
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    const isColumnLayout = $attr(`layout`) === `column`;;
    const selected = stagingSelected || $attr(`selected`);;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          [`${$attr(`layout`)}-layout`]: true
        }, {
          'mp-query-multi-block': true
        }),
      }, (function() {
        var __jade_nodes = []; /*  current blocks */
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = (selected);
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, selection, idx) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(jade_mixins['multi-block-item'].call(this, selection, idx));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var idx = $$objKey;
                if ($$obj.hasOwnProperty(idx)) {
                  $$iterated = true;
                  var selection = $$obj[idx];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(jade_mixins['multi-block-item'].call(this, selection, idx));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })()); /*  button to add more selectors */
        __jade_nodes = __jade_nodes.concat((!$attr(`adding-disabled`) && $helpers.canAddMore()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((prefixRenderer) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-multi-block-prefix': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(prefixRenderer(selected.length, null));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "key": `new-block-item`,
            "class": {
              'mp-query-multi-block-item': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-query-block", {
              "attrs": __vjadeStringifyAttrsIfObj($helpers.getQueryBlockAttrs({
                'selector-icon': $attr(`button-icon`),
                'selector-type': $attr(`button-selector-type`),
                'theme': $attr(`button-selector-theme`),
                'label': $helpers.buttonText(),
                'input-only': !$attr(`not-button-input-only`),
                'open': $attr(`button-open`) || addingBlock,
                'elref': `addBlock`,
                'tooltip-data': $attr(`tooltip-data-index`) === null ? $attr(`tooltip-data`) : null,
              })),
              "dataset": {
                key: `new-block`,
              },
              "on": {
                select: $helpers.commitNewBlock,
                track: $helpers.preventTracking,
                open: () => $helpers.setAddingBlock(true),
                close: $helpers.onAddItemBlockClose,
              },
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "addingBlock" in locals ? locals.addingBlock : typeof addingBlock !== "undefined" ? addingBlock : undefined, "prefixRenderer" in locals ? locals.prefixRenderer : typeof prefixRenderer !== "undefined" ? prefixRenderer : undefined, "stagingSelected" in locals ? locals.stagingSelected : typeof stagingSelected !== "undefined" ? stagingSelected : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;